import {environment} from "./../../environments/environment";
export var srv_url: string = environment.HTTP_BASE_URL;
export var kyungnamIsTrue : boolean = environment.kyungnamIsTrue;
export var nambuIsTrue : boolean  = environment.nambuIsTrue;
export var dtaqIsTrue : boolean = environment.dtaqIsTrue;
//export var srv_url: string = "https://www.extrus.net:19446/exafe_admin";
export var shIsTrue : boolean = environment.shIsTrue;
export var acuonIsTrue : boolean = environment.acuonIsTrue;
export var visitorLocationIsTrue : boolean = environment.visitorLocationIsTrue;
export var visitorInfoModifyIsTrue : boolean = environment.visitorInfoModifyIsTrue;
export var officeVersionShow : boolean = environment.officeVersionShow;
export var inOutShow : boolean = environment.inOutShow;


// WEBPACK FOOTER //
// ./src/app/service/global_url.ts